import { CommApiInstance } from "Utils/CommApiInstance";




const MembIdntMktgAddrApi = async (
) => {
    return await CommApiInstance.post("memb/idnt_mktg_addr",{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default MembIdntMktgAddrApi;